import { useMemo } from 'react';
import ReactECharts from 'echarts-for-react';
import { useChartPalette } from '../../../theme/chartPalette';
import { GUIDE_FONT_FAMILY } from '../../../theme/guideTokens';
import { MonthCount } from './PractitionerAccountStatement.Functions';

/**
 * Visitas por mes, como "Facturado vs. cobrado por mes" del screen design: barras en el primer color
 * de la paleta del tema con las esquinas de arriba redondeadas, sólo la línea base (sin eje Y ni
 * grilla), meses y valores en texto secundario 13 y tooltip oscuro de la guía.
 */
export const VisitsByMonthChart = ({ points, seriesName }: { points: MonthCount[]; seriesName: string }) => {
    const palette = useChartPalette();

    const option = useMemo(() => ({
        backgroundColor: 'transparent',
        textStyle: { fontFamily: GUIDE_FONT_FAMILY },
        grid: { left: 8, right: 8, top: 24, bottom: 8, containLabel: true },
        tooltip: {
            trigger: 'axis',
            axisPointer: { type: 'shadow', shadowStyle: { color: palette.gridLine, opacity: 0.4 } },
            backgroundColor: palette.tooltipBackground,
            borderColor: palette.tooltipBackground,
            borderRadius: 4,
            padding: [8, 12],
            textStyle: { color: palette.tooltipText, fontFamily: GUIDE_FONT_FAMILY, fontSize: 13 }
        },
        xAxis: {
            type: 'category',
            data: points.map((point) => point.label),
            axisTick: { show: false },
            axisLine: { lineStyle: { color: palette.axisLine } },
            axisLabel: { color: palette.textSecondary, fontFamily: GUIDE_FONT_FAMILY, fontSize: 13 }
        },
        yAxis: {
            type: 'value',
            minInterval: 1,
            show: false
        },
        series: [{
            name: seriesName,
            type: 'bar',
            data: points.map((point) => point.count),
            itemStyle: { color: palette.series[0], borderRadius: [3, 3, 0, 0] },
            label: { show: points.length <= 12, position: 'top', color: palette.textSecondary, fontFamily: GUIDE_FONT_FAMILY, fontSize: 13 },
            barMaxWidth: 34
        }]
    }), [points, palette, seriesName]);

    return (
        <div className="pas-chart" data-testid="pas-visits-chart">
            <ReactECharts option={option} style={{ height: 220, width: '100%' }} notMerge lazyUpdate />
        </div>
    );
};

export default VisitsByMonthChart;
